import { z } from 'zod';

export const ReceiptType = z.enum([
    'trainticket',
    'meal',
    'airlineticket',
    'hotel',
    'rentalcar',
    'publicTransportation',
    'taxi',
    'internet',
    'envelope',
    'gasolineCompanyCar',
    'gasolineRentalCar',
    'parking',
    'creditCardVoucher',
    'ownReceipt',
    'milageAllowance',
    'otherreceipt',
]);
export type ReceiptType = z.infer<typeof ReceiptType>;
